<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 38px;
        font-weight: bold;
        color: #05523e;
        padding-top: 50px;
      "
    >
      Edit Invoice
    </v-card-title>
    <div class="print">
      <div style="margin-right: 20px">
        <v-btn-toggle
          v-model="selectedStatus"
          v-on:change="selectStatus"
          tile
          color="#05523E"
          group
        >
          <v-btn value="C"
            ><span style="font-weight: bold; font-size: 16px">C</span></v-btn
          >
          <v-btn value="V"
            ><span style="font-weight: bold; font-size: 16px">V</span></v-btn
          >
          <v-btn value="O"
            ><span style="font-weight: bold; font-size: 16px">O</span></v-btn
          >
        </v-btn-toggle>
      </div>
      <v-icon color="black" size="35" @click="printPdf">mdi-printer</v-icon>
    </div>

    <div style="margin-left: 60px; margin-bottom: 1%">
      <div class="description">
        <span>Invoice Number</span>
        <span>{{ $store.state.invoice.invoiceOne.invoiceNumber }}</span>
      </div>
      <v-row class="ma-0" justify="space-between">
        <div class="description">
          <span>Company Name</span>
          <span>{{ $store.state.invoice.invoiceOne.companyName }}</span>
        </div>
        <v-btn
          class="action white--text elevation-5"
          color="#05523E"
          style="
            min-width: 100px;
            font-size: 15px;
            font-weight: bold;
            height: 35px;
            margin: 12px;
          "
          @click="showTemplate"
          >Add Template</v-btn
        >
      </v-row>
    </div>
    <div
      style="
        display: flex;
        justify-content: end;
        width: 100%;
        align-items: center;
      "
    >
      <v-col cols="6">
        <v-row justify="end">
          <v-col cols="3">
            <v-text-field
              hide-details="true"
              outlined
              dense
              label="Search Item"
              placeholder="Please input description"
              v-model="searchItemForDescription"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div style="margin: auto 20px">
      <v-data-table
        :headers="headers"
        :items="
          !searchItemForDescription
            ? $store.state.invoice.invoiceOne.itemList
            : $store.state.invoice.invoiceOne.itemList.filter((item) =>
                searchItem(
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ''
                  })`
                )
              )
        "
        :page.sync="page_No"
        :items-per-page="$store.state.invoice.invoiceOne.itemList.length"
        hide-default-footer
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                </template> -->
        <template v-slot:item="{ item, index }">
          <tr
            :style="{
              'background-color':
                item.Quantity > item.In_Stock
                  ? 'rgba(250,22,22,0.21)'
                  : 'rgba(250,255,255)',
            }"
          >
            <td>{{ item.LineNum }}</td>
            <td>
              <v-text-field
                @input="
                  setMappingInput(item);
                  setGrandTotal();
                  setProfit(item);
                "
                @blur="applyData(item)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                v-model="item.Quantity"
                style="margin: auto 10px; max-width: 50px; min-width: 50px"
              />
            </td>
            <td>{{ item.In_Stock }}</td>
            <td>{{ item.ItemNum }}</td>
            <td>
              <text-highlight
                :queries="searchItemForDescription"
                :caseSensitive="false"
                >{{
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ""
                  })`
                }}</text-highlight
              >
              <!-- <span
                :class="{
                  highlight: searchItem(
                    `${item.ItemName}(${
                      item.ItemName_Extra || item.Vendor_Part_Num || ''
                    })`
                  ),
                }"
              >
                {{
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ""
                  })`
                }}
              </span> -->
            </td>
            <td>{{ item.CostPer }}</td>
            <td>{{ item.ChargedPrice }}</td>
            <td>
              <v-text-field
                @input="
                  setGrandTotal();
                  setProfit(item);
                "
                @blur="applyData(item)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                v-model="item.PricePer"
                style="margin: auto 10px; max-width: 70px; min-width: 70px"
              />
            </td>
            <td>
              {{
                roundToTwo(
                  roundToTwo(item.PricePer) * 1 * roundToTwo(item.Quantity)
                )
              }}
            </td>
            <td>
              {{ item.Profit }}
            </td>
            <td>
              {{ item.ProfitPer }}
            </td>
            <td>
              <v-btn
                style="font-size: 12px; color: #05523e"
                @click="openPriceModal(item)"
              >
                Latest prices
              </v-btn>
            </td>
            <td>
              <v-btn
                style="font-size: 15px"
                color="rgb(216, 108, 108)"
                @click="removeItem(item, index)"
              >
                <v-icon color="white">mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider />
      <div class="total">
        <span>Grand Total: </span>
        <span style="margin-left: 25px"
          >$ {{ roundToTwo($store.state.invoice.invoiceOne.GrandTotal * 1) }}
        </span>
        <span style="margin-left: 25px">Grand Profit: </span>
        <span style="margin-left: 25px"
          >$ {{ !isNaN(grandProfit) ? roundToTwo(grandProfit * 1) : 0 }}
        </span>
        <span style="margin-left: 25px">Grand ProfitPer: </span>
        <span style="margin-left: 25px"
          >{{ !isNaN(grandProfitPer) ? roundToTwo(grandProfitPer * 1) : 0 }}
          %
        </span>
      </div>
    </div>
    <v-card-actions style="padding-right: 50px; justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="$store.commit('common/changeEditInvoiceOneModalView')"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="editInvoice"
        >Edit</v-btn
      >
    </v-card-actions>
    <v-dialog v-model="$store.state.common.latestPriceModalView" width="900">
      <LatestPriceModal :currentDescription="currentDescription" />
    </v-dialog>
    <div v-if="templateModal">
      <v-dialog v-model="templateModal" width="1500">
        <EditInvoiceTemplateModal
          :loading="loading"
          style="min-height: 300px"
          v-bind:custNum="$store.state.invoice.invoiceOne.custNum"
          v-bind:companyName="$store.state.invoice.invoiceOne.companyName"
          @closeModal="closeModal"
          @addTemplateList="addTemplateList"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery, runGqlMutation } from "@/graphql/gqlUtil.js";
import LatestPriceModal from "@/components/modal/LatestPriceModal.vue";
import EditInvoiceTemplateModal from "@/components/modal/EditInvoiceTemplateModal.vue";
import { debounce } from "lodash";
import {
  GETINVOICE,
  GETLATESTPRICE,
  CHECKITEMANDCRV,
  GETINVENTORYFORTAG,
} from "@/graphql/InvoiceQueries.js";
import { DELETE_INVOICE } from "@/graphql/InvoiceMutations.js";
import Demical, { Decimal } from "decimal.js";
import {
  UPDATEINVOICE,
  UPDATEINVOICESTATUS,
} from "@/graphql/InvoiceMutations.js";

export default {
  components: {
    LatestPriceModal,
    EditInvoiceTemplateModal,
  },
  data() {
    return {
      currentDescription: "",
      searchItemForDescription: "",
      grandProfitPer: 0,
      grandProfit: 0,
      templateModal: false,
      headers: [
        {
          // sort: (a, b) => a.localeCompare(b),
          text: "#",
          align: "start",
          value: "LineNum",
          sortable: true,
        },
        {
          text: "QTY/LB",
          value: "QuantityApply",
          // sort: (a, b) => a - b,
        },
        {
          text: "Stock",
          value: "In_Stock",
          // sort: (a, b) => a - b,
        },
        {
          text: "ITEM NUMBER",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "DESCRIPTON",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "COST ($)",
          value: "CostPer",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Charged Price ($)",
          value: "ChargedPrice",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "PRICE ($)",
          value: "PriceApply",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "EXTENDED ($)",
          value: "Total",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Profit",
          value: "Profit",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "ProfitPer (%)",
          value: "ProfitPer",
          // sort: (a, b) => a.localeCompare(b),
        },
        { text: "", sortable: false },
        { text: "", sortable: false },
      ],
      page_No: 0,
      selectedStatus: this.propStatus,
    };
  },
  watch: {
    "$store.state.invoice.invoiceOne.itemList": function (newVal, oldVal) {
      if (newVal.length > 0) {
        this.setGrandTotal();
        newVal.map((item) => {
          this.setProfit(item);
        });
      }
    },
  },
  beforeDestroy() {
    this.$store.state.invoice.invoiceOne.itemList = [];
  },
  props: ["propStatus", "loading"],
  async created() {
    // this.setGrandTotal = debounce(this.setGrandTotal, 400);
    // this.setProfit = debounce(this.setProfit, 400);
    // this.setMappingInput = debounce(this.setMappingInput, 400);
    await this.$store.dispatch("invoice/getCategory");
    this.setGrandTotal();
  },

  updated() {},

  methods: {
    async setMappingInput(item, index) {
      if (item.MappingLineNum || item.MappedLineNum) {
        const findIndex =
          this.$store.state.invoice.invoiceOne.itemList.findIndex((item1) =>
            item.MappingLineNum
              ? item1.LineNum === item.MappingLineNum && item1.Type === "CRV"
              : item1.LineNum === item.MappedLineNum && item1.Type === "Item"
          );
        console.log(this.$store.state.invoice.invoiceOne.itemList[findIndex]);
        this.$store.state.invoice.invoiceOne.itemList[findIndex].Quantity =
          item.Quantity;
        this.setProfit(
          this.$store.state.invoice.invoiceOne.itemList[findIndex]
        );
      }
    },
    // setMappingInput(item) {

    //   console.log(item);
    //   console.log(this.$store.state.invoice.invoiceOne.itemList);
    //   if (item)
    //     if (item.MappingLineNum || item.MappedLineNum) {
    //       // 매핑이 있다면
    //       const findIndex =
    //         this.$store.state.invoice.invoiceOne.itemList.findIndex((item1) => {
    //           console.log(item1.LineNum, item.MappingLineNum);
    //           return item.MappingLineNum
    //             ? item1.LineNum === item.MappingLineNum
    //             : item1.LineNum === item.MappedLineNum;
    //         });
    //       console.log(findIndex);
    //       console.log(item.Quantity);
    //       this.$store.state.invoice.invoiceOne.itemList[findIndex].Quantity =
    //         item.Quantity;
    //     }
    // },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    searchItem(item) {
      const target = this.searchItemForDescription
        .toUpperCase()
        .replace(/ /gi, "");
      const trimItem = item.toUpperCase().replace(/ /gi, "");
      if (!target) return false;
      if (trimItem === target) return true;
      return trimItem.includes(target) ? true : false;
    },
    closeModal() {
      console.log("??");
      this.templateModal = false;
    },
    applyData(item) {
      item.QuantityApply = item.Quantity;
      item.PriceApply = item.PricePer;
    },
    setProfit(item) {
      item.Profit = this.roundToTwo(
        item.PricePer * 1 * item.Quantity - item.CostPer * 1 * item.Quantity
      );
      item.ProfitPer =
        item.Quantity != 0
          ? this.getProfitPer2(item.PricePer, item.CostPer)
          : 0;
    },
    async addTemplateList(selected) {
      console.log(selected);

      let add = [];
      let LineNum = this.$store.state.invoice.invoiceOne.itemList.map(
        (item) => item.LineNum
      );
      let maxNum = Math.max(...LineNum);
      if (!isFinite(maxNum)) maxNum = 1;
      if (this.$store.state.invoice.invoiceOne.itemList.length > 0) ++maxNum;
      for (let i = 0; i < selected.length; i++) {
        console.log(maxNum);
        const checkCrv = await runGqlQuery(CHECKITEMANDCRV, {
          ItemNum: `${selected[i].ItemNum}`,
        });
        if (checkCrv.checkItemAndCRV.ItemType === "NONE") {
          add.push({
            ...selected[i],
            LineNum: maxNum++,
            QuantityApply: selected[i].Quantity,
            PriceApply: selected[i].Price,
            Profit: 0,
            ProfitPer: 0,
          });
        } else if (checkCrv.checkItemAndCRV.ItemType === "ITEM") {
          add.push({
            ...selected[i],
            Type: "Item",
            LineNum: maxNum++,
            MappingLineNum: maxNum,
            QuantityApply: selected[i].Quantity,
            PriceApply: selected[i].Price,
            Profit: 0,
            ProfitPer: 0,
          });
          console.log(checkCrv.checkItemAndCRV.TagItemNum[0]);
          const item = await runGqlQuery(GETINVENTORYFORTAG, {
            ItemNum: `${checkCrv.checkItemAndCRV.TagItemNum[0]}`,
            CustNum: `${this.$store.state.invoice.invoiceOne.custNum}`,
          });
          console.log(item.getInventory);
          const TotalTag = this.roundToTwo(
            item.getInventory.Price * 1 * selected[i].Quantity
          );
          add.push({
            ...item.getInventory,
            ChargedPrice: item.getInventory.ChargedPrice,
            LineNum: maxNum++,
            MappedLineNum: maxNum - 2,
            Type: "CRV",
            QuantityApply: selected[i].Quantity,
            Quantity: selected[i].Quantity,
            PriceApply: item.getInventory.Price,
            Profit: 0,
            ProfitPer: 0,
            PricePer: item.getInventory.Price,
            Price: item.getInventory.Price,
            CostPer: item.getInventory.Cost,
            Total: TotalTag,
          });
        }
        // ++maxNum;
      }

      // let add = selected.map((item, index) => {
      //   // const checkCrv = await runGqlQuery(CHECKITEMANDCRV, {
      //   //   ItemNum: `${item.ItemNum}`,
      //   // });
      //   // if (checkCrv.checkItemAndCRV.ItemType === "NONE")
      //   return {
      //     ...item,
      //     // LineNum: maxNum + (index + 1),
      //     QuantityApply: item.Quantity,
      //     PriceApply: item.Price,
      //     Profit: 0,
      //     ProfitPer: 0,
      //   };
      //   // return {
      //   //   ...item,
      //   //   // LineNum: maxNum + (index + 1),
      //   //   QuantityApply: item.Quantity,
      //   //   PriceApply: item.Price,
      //   //   Profit: 0,
      //   //   ProfitPer: 0,
      //   // };
      // });
      console.log();
      this.$store.state.invoice.invoiceOne.itemList.push(...add);
      this.templateModal = false;
      // this.$store.state.invoice.invoiceOne.itemList =
      //   this.$store.state.invoice.invoiceOne.itemList.filter((item1, idx1) => {
      //     return (
      //       this.$store.state.invoice.invoiceOne.itemList.findIndex(
      //         (item2, idx2) => {
      //           return item1.ItemNum == item2.ItemNum;
      //         }
      //       ) == idx1
      //     );
      //   });
    },
    async showTemplate() {
      await this.$store.dispatch("invoice/getTemplates", {
        CustNum: this.$store.state.invoice.invoiceOne.custNum,
      });
      this.templateModal = !this.templateModal;
    },
    removeItem(item, index) {
      // this.$store.state.invoice.invoiceOne.itemList =
      //   this.$store.state.invoice.invoiceOne.itemList.filter(
      //     (item2, index2) => {
      //       // return item.ItemNum != item2.ItemNum;
      //       return index2 != index;
      //     }
      //   );
      this.$store.state.invoice.invoiceOne.itemList =
        this.$store.state.invoice.invoiceOne.itemList.filter(
          (item2, index2) => {
            return index2 != index;
          }
        );
      if (item.MappedLineNum !== undefined) {
        this.$store.state.invoice.invoiceOne.itemList =
          this.$store.state.invoice.invoiceOne.itemList.filter(
            (item2, index2) => {
              return index2 !== index - 1;
            }
          );
      }
      if (item.MappingLineNum !== undefined) {
        this.$store.state.invoice.invoiceOne.itemList =
          this.$store.state.invoice.invoiceOne.itemList.filter(
            (item2, index2) => {
              return index2 !== index;
            }
          );
      }
    },
    isOver(quantity, stock) {
      if (quantity > stock) {
        return true;
      } else {
        return false;
      }
    },
    setGrandTotal() {
      const arr = [...this.$store.state.invoice.invoiceOne.itemList];
      this.$store.state.invoice.invoiceOne.GrandTotal = this.roundToTwo(
        arr.reduce((pre, cur, i) => {
          return pre + this.roundToTwo(cur.PricePer * cur.Quantity);
        }, 0)
      );
      console.log(this.$store.state.invoice.invoiceOne.GrandTotal);
      //   getProfitPer(
      //                   (item.Price * 1 * item.Quantity) /
      //                     (item.Cost * 1 * item.Quantity)
      //                 )
      const costTotal = this.roundToTwo(
        arr.reduce((pre, cur, i) => {
          return pre + this.roundToTwo(cur.CostPer * 1 * cur.Quantity);
        }, 0)
      );
      this.grandProfit =
        this.$store.state.invoice.invoiceOne.GrandTotal - costTotal;
      this.grandProfitPer =
        this.getProfitPer(
          (this.$store.state.invoice.invoiceOne.GrandTotal - costTotal) /
            costTotal
        ) * 100;
    },
    getProfitPer(num) {
      //   return common.roundToTwo(num);

      Decimal.set({
        rounding: 4,
      });
      return Number.parseFloat(Demical(num));
    },
    getProfitPer2(price, cost) {
      return this.round(
        ((Demical((price * 1 - cost * 1) / cost) * 1 * 100) / 1).toFixed(3)
      );
      //this.getProfitPer(
      //);
    },
    round(num) {
      var m = Number((Math.abs(num) * 100).toPrecision(15));
      return (Math.round(m) / 100) * Math.sign(num);
    },
    typeMoney: (money) => {
      if (typeof money !== "number" && money === "0.0") {
        return money;
      } else if (0 <= money && money < 1000) {
        money += "";
        const sep = money.split(".");

        if (sep[1] !== undefined && sep[1].length > 2) {
          sep[1] = sep[1].substring(0, 3);
          sep[1] /= 10;
          sep[1] = Math.round(sep[1]);
          return sep[0] + "." + sep[1];
        }

        return money;
      } else if (money < 0 || 1000 <= money) {
        let ifMinus = false;

        if (money < 0) {
          ifMinus = true;
          money = Math.abs(money);
        }

        money += "";
        const sep = money.split(".");
        let result = "";

        for (let i = 1; i <= sep[0].length; i++) {
          result = sep[0][sep[0].length - i] + result;
          if (i % 3 === 0 && i !== sep[0].length) {
            result = "," + result;
          }
        }

        if (sep[1] !== undefined) {
          if (sep[1].length > 2) {
            sep[1] = sep[1].substring(0, 3);
            sep[1] /= 10;
            sep[1] = Math.round(sep[1]);
          }
          result += "." + sep[1];
        }
        if (ifMinus) result = "-" + result;
        return result;
      }
    },
    async selectStatus() {
      try {
        if (
          this.selectedStatus === undefined ||
          this.selectedStatus === this.$store.state.invoice.invoiceOne.status
        )
          return;

        const req = {
          Invoice_Number:
            this.$store.state.invoice.invoiceOne.invoiceNumber + "",
          Status: this.selectedStatus,
        };

        const result = await runGqlMutation(UPDATEINVOICESTATUS, req);

        if (result.message === undefined) {
          this.$store.state.invoice.invoiceOne.status = this.selectedStatus;
          this.$emit("getInvoiceList", true);
          await this.$store.commit("common/snackOn", {
            text: "Invoice status has changed.",
          });
        } else {
          await this.$store.commit("common/snackErrOn", {
            text: "Invoice state change failed.",
          });
          this.selectedStatus = this.$store.state.invoice.invoiceOne.status;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async openPriceModal(item) {
      try {
        this.currentDescription = `${item.ItemName}(${
          item.ItemName_Extra || item.Vendor_Part_Num || ""
        })`;
        const priceResult = await runGqlQuery(GETLATESTPRICE, {
          ItemNum: item.ItemNum,
        });

        if (
          priceResult !== undefined &&
          priceResult.getLatestPrice.length !== 0
        ) {
          await this.$store.commit(
            "invoice/setLatestPrices",
            priceResult.getLatestPrice
          );
        } else {
          await this.$store.commit("common/snackErrOn", {
            text: "There are no recent prices!",
          });
          return;
        }

        await this.$store.commit("common/changeLatestPriceModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async printPdf() {
      try {
        let popup = window.open("/", "", "width=800px, height=800px;");
        popup.document.write(`
                    <style>
                        @page {
                            size: A4;
                        }
                        @media print {
                            html, body {
                                width:210mm;
                                height:297mm;
                            }
                        }
                        .middle > table {
                            border-collapse:collapse;
                        }
                        .middle>tr {
                          padding: 5px;
                          border:1px solid #cccccc;
                        }
                        .middle > td {
                          padding-left: 5px;
                        }
                    </style>
                    <html>
                        <body>
                            <!-- top -->
                            <div style="width:210mm;">
                              <div style="font-size: 25pt;"><b>CENTRAL AVE</b></div>
                              <div>1206 East 6th St.Los Angeles, CA 90021</div>
                              <div>T 213-688-4099 F 213-458-5114</div>
                              <br /><br />
                              <div style="font-size: 25pt;"><b>INVOICE # ${this.$store.state.invoice.originInvoice.invoiceNumber}</b></div>
                              <table class="top"style="width:100%; " >
                                <colgroup>
                                    <col style="width:20%;">
                                    <col style="width:30%;">
                                    <col style="width:50%;">
                                </colgroup>
                                <tr>
                                  <td>DATE</td>
                                  <td>${this.$store.state.invoice.originInvoice.date}</td>
                                  <td>${this.$store.state.invoice.originInvoice.custNum} -- ${this.$store.state.invoice.originInvoice.companyName}</td>
                                </tr>
                                <tr>
                                  <td>CASHIER</td>
                                  <td>${this.$store.state.account.userInfo.Cashier_ID}</td>
                                  <td>${this.$store.state.invoice.originInvoice.address}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td>${this.$store.state.invoice.originInvoice.phone}</td>
                                </tr>
                              </table>
                            </div>
                            <!-- middle -->
                            <div class="middle" style="width:210mm;">
                              <table style="width:100%; margin-top: 15px;" >
                                <colgroup>
                                      <col style="width:5%;">
                                      <col style="width:10%;">
                                      <col style="width:18%;">
                                      <col style="width:40%;">
                                      <col style="width:12%;">
                                      <col style="width:15%;">
                                </colgroup>
                                <tr style="border:1px solid #cccccc;">
                                  <td><b>#</b></td>
                                  <td><b>QTY/LB</b></td>
                                  <td><b>ITEM NUMBER</b></td>
                                  <td><b>DESCRIPTION</b></td>
                                  <td><b>PRICE PER</b></td>
                                  <td><b>EXTENDED</b></td>
                                </tr>
                `);
        for (
          let i = 0;
          i < this.$store.state.invoice.originInvoice.itemList.length;
          i++
        ) {
          popup.document.write(`
                    <tr style="border:1px solid #cccccc;">
                      <td>${
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .LineNum
                      }</td>
                      <td>${
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .Quantity
                      }</td>
                      <td>${
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .ItemNum
                      }</td>
                      <td>${
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .ItemName +
                        " " +
                        (this.$store.state.invoice.originInvoice.itemList[i]
                          .ItemName_Extra ||
                          this.$store.state.invoice.originInvoice.itemList[i]
                            .Vendor_Part_Num)
                      }</td>
                      <td>${
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .PricePer
                      }</td>
                      <td>${this.roundToTwo(
                        this.$store.state.invoice.originInvoice.itemList[i]
                          .PricePer *
                          1 *
                          this.$store.state.invoice.originInvoice.itemList[i]
                            .Quantity
                      )}</td>
                    </tr>
                  `);
        }
        popup.document.write(`
                            <!-- tail -->
                            <div class="tail" style="width:210mm;">
                              <table style="width:100%; margin-top: 15px;" >
                                <colgroup>
                                      <col style="width:50%;">
                                      <col style="width:50%;">
                                </colgroup>
                                <tr style="border:1px solid #cccccc;">
                                  <td style="font-size: 8px; border:1px solid #cccccc;">
                                    Balance: ###<br/><br/>1.All claims must be made within 5days<br />&nbsp;&nbsp;after recept of goods.
                                    <br />2. Service charge of 1.5% per month will be <br/>&nbsp;&nbsp; charged receipt of goods.
                                    <br />3. $30.00 for each returned check will be <br/>&nbsp;&nbsp; added as a handling charge.
                                    <br />4. In the event of lawsuit, all expenses <br />&nbsp;&nbsp; shall be the buyer's responsbility.
                                    <br />5. Buyer's agreed with all consents to the <br/> &nbsp;&nbsp; jurisdiction of CA or federal court in LA.
                                  </td>
                                  <td style="font-size: 12px; border:1px solid #cccccc;">
                                    Cash Sale
                                    <br />
                                    <div style="display: flex; justify-content: space-between"><div>Sub Total:</div><div>$${this.roundToTwo(
                                      this.$store.state.invoice.originInvoice
                                        .GrandTotal
                                    )}</div></div>
                                    <div style="display: flex; justify-content: space-between"><div><b>Grand Total:</b></div><div><b>$${this.roundToTwo(
                                      this.$store.state.invoice.originInvoice
                                        .GrandTotal
                                    )}</b></div></div>
                                    <br /><br /><br /><br /><br /><br /><br />
                                  </td>
                                </tr>
                              </table>
                            </div>
                        </body>
                    </html>
                `);
        popup.print();
        popup.close();
      } catch (err) {
        console.error(err);
      }
    },
    async editInvoice() {
      try {
        if (this.$store.state.invoice.invoiceOne.itemList.length < 1) {
          const confirm = window.confirm(
            "There are no items left. If you delete all the items, the invoice will be deleted. Shall we proceed with the deletion?"
          );
          if (confirm) {
            try {
              const req = {
                Invoice_Number:
                  this.$store.state.invoice.invoiceOne.invoiceNumber + "",
              };
              // 삭제 로직
              const deleteInvoice = await runGqlMutation(DELETE_INVOICE, req);

              if (deleteInvoice.message === undefined) {
                if (deleteInvoice.deleteInvoice.ResultCount == 1) {
                  this.$store.commit("common/snackOn", {
                    text: "Invoice Delete Complete!",
                  });
                  this.$emit("getInvoiceList", true);
                  this.$store.state.common.editInvoiceOneModalView = false;
                } else {
                  this.$store.commit("common/snackErrOn", {
                    text: "Invoice Delete Failed.",
                  });
                }
              } else {
                this.$store.commit("common/snackErrOn", {
                  text: `Invoice Delete Failed. ${this.$store.state.common.errorMessage}`,
                });
              }
            } catch (error) {
              this.$store.commit("common/snackErrOn", {
                text: `Invoice Delete Failed. ${error}`,
              });
            }
          }
          return;
        }
        const req = {
          Invoice_Number:
            this.$store.state.invoice.invoiceOne.invoiceNumber + "",
        };
        let tempArray = [];

        this.$store.state.invoice.invoiceOne.itemList.map((data) => {
          tempArray.push({
            ItemNum: data.ItemNum,
            Quantity: data.Quantity * 1,
            PricePer: data.PricePer * 1,
          });
        });

        req.Items = tempArray;
        const filter = tempArray.filter((item) => item.Quantity == 0);
        if (filter.length !== tempArray.length) {
          // 다 0이 아닐때
          const updateResult = await runGqlMutation(UPDATEINVOICE, req);

          if (updateResult.message === undefined) {
            await this.$store.commit("common/snackOn", {
              text: "Invoice Edit Complete!",
            });

            const invoiceResult = await runGqlQuery(GETINVOICE, {
              column: "Invoice_Number",
              search: this.$store.state.invoice.invoiceOne.invoiceNumber + "",
            });

            if (
              invoiceResult !== undefined &&
              invoiceResult.getInvoices.length !== 0
            ) {
              await this.$store.commit(
                "invoice/setInvoiceOne",
                invoiceResult.getInvoices[0]
              );
            } else {
              await this.$store.commit("common/snackOn", {
                text: "Invoice Get Failed!",
              });
            }
          } else {
            await this.$store.commit("common/snackErrOn", {
              text: "Invoice Edit Failed.",
            });
          }
        } else {
          // 다 0일때
          await this.$store.commit("common/snackOn", {
            text: "Please order at least one item",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  position: absolute;
  display: flex;
  right: 30px;
  top: 50px;
}
.total {
  font-weight: bold;
  font-size: 17px;
  display: flex;
  justify-content: flex-end;
  margin-top: 1%;
  margin-right: 4%;
}
.description {
  display: flex;
  flex-flow: wrap;
}
.description > span:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
  width: 160px;
}
.description > span:nth-child(2) {
  font-size: 20px;
}
.highlight {
  font-weight: 600;
  /* color: #ff0000; */
  background-color: #ffff00;
}
</style>
